import { UnifiedWorkItemsQuery } from "generated-graphql/graphql";

export type UnifiedWorkRow = UnifiedWorkItemsQuery["unifiedWorkItems"]["items"][number];

/** Why an unassignable row is unassignable, said in the tooltip rather than implied. */
export const NO_ACTIVITY_TO_ASSIGN =
  "No active step to assign — this workflow has no current activity";

/**
 * The other reason a row cannot be assigned here: its subject owns the answer.
 * A registrar-minted submission row takes its owner from the submission's staff
 * assignee on every reconcile, so an edit made on the queue would be overwritten
 * within the day. Shown as visible text as well as the tooltip — this one sends
 * staff somewhere else, so it has to be readable without hovering a dead control.
 */
export const ORIGIN_OWNS_ASSIGNMENT =
  "Assignment comes from the submission's staff assignee; edit it on the submission.";

/**
 * The reason this row's assign controls are dead, or null when they are live.
 *
 * Lives here rather than in the drawer because the bulk menu needs the same
 * answer for a whole selection: a row the drawer would refuse individually is a
 * row the bulk action has to leave out, and saying so needs the same words.
 */
export function assignBlockedReason(row: UnifiedWorkRow): string | null {
  if (row.assigneeReadOnly) {
    return ORIGIN_OWNS_ASSIGNMENT;
  }
  if (!row.activityId) {
    return NO_ACTIVITY_TO_ASSIGN;
  }
  return null;
}

/**
 * The rows an assignment can actually be written to: they need a current
 * activity to hang the assignee off, and they must not be a row whose subject
 * owns the answer.
 */
export function assignableRows(rows: UnifiedWorkRow[]): UnifiedWorkRow[] {
  return rows.filter((row) => assignBlockedReason(row) === null);
}
